const reportsTestIDs = {
  reportTitle: 'report-title',
  reportDescription: 'report-description',
  reportEmptyMessageTitle: 'report-empty-message-title',
  reportEmptyMessageBody: 'report-empty-message-body',
  reportClientsSectionTitle: 'report-clients-section-title',
  reportSortModal: 'report-sort-modal',
  reportSortButton: 'report-sort-button',
  reportSortButtonLabel: 'report-sort-button-label',
  reportSortByHeader: 'sort-header',
  reportFilterButton: 'report-filter-button',
  reportFiltersOption: 'report-filters-option',
  reportSortOption: 'report-sort-option',
  reportFilterDescription: 'report-filter-description',

  reportNewFrontlineClient: 'report-new-frontline-client',
  personNameView: 'report-name-view',
  personName: 'report-person-name',
  reportClientFullName: 'report-client-full-name',
  reportClientRole: 'report-client-role',
  reportCoachName: 'report-coach-name',
  reportCoachRank: 'report-coach-rank',

  reportClientLastOrderedDate: 'report-client-last-ordered-date',
  reportActivatedOn: 'report-client-activated-on',
  reportClientExpiringRewards: 'report-client-expiring-rewards',
  reportClientExpiringRewardsAmount: 'report-client-expiring-rewards-amount',
  reportClientExpiringRewardsDate: 'report-client-expiring-rewards-date',
  reportClientExpiringWellnessCredits: 'report-client-expiring-wc',
  reportClientExpiringWellnessCreditsDate: 'report-client-expiring-wc-date',
  reportClientExpiringWellnessCreditsAmount: 'report-client-expiring-wc-amount',
  reportClientSponsoredOn: 'report-client-sponsored-on',
  reportCoachGQV: 'report-coach-gqv',
  reportCoachFqv: 'report-coach-fqv-count',
  reportCoachSCTeams: 'report-coach-SCTeams-count',
  reportCoachFibcCount: 'report-coach-fibc-count',
  reportCoachOe: 'report-coach-oe',
  reportCancelledPremierOn: 'report-cancelled-premier-on',
  reportScheduledPremierOrder: 'report-scheduled-premier-order',
  reportPreviousHraRank: 'report-previous-hra-rank',
  reportNewHraRank: 'report-new-hra-rank',
  reportHraRank: 'report-hra-rank',
  reportFqvNoeCount: 'report-fqv-noe-count',
  reportEligibleUntil: 'report-eligible-until',
  reportEligibleOE: 'report-eligible-oe',
  reportOEawayFromBonus: 'report-oe-away-from-bonus',
  reportEligibleFQV: 'report-eligible-fqv',
  reportLicenseExpiringOn: 'report-license-expiring-on',
  reportQsbEarnedDaysAgo: 'report-qsb-earned-days-ago',
  reportQsbEligibleUntil: 'report-qsb-eligible-until',
  reportABEligibleThrough: 'report-eligible-through',
  reportLastEarned: 'report-last-earned',
  reportNextTask: 'report-next-task',
  reportItPath: 'report-it-path',
  reportNewTag: 'report-new-tag',
  reportFiltersScrollView: 'report-filters-scrollview',
  reportFilterButtonLabel: 'report-filter-label',
  reportFilterClearFiltersView: 'report-clear-filters-view',
  reportFilterClearFiltersButton: 'report-clear-filters-button',
  reportFilterGeneration: 'report-filter-generation',
  reportGeneration: 'report-generation',
  reportFilterProductType: 'report-filter-product-type',
  reportFilterAccountStatus: 'report-filter-account-status',
  reportFiltersModal: 'report-filters-modal-window',
  reportFiltersModalClose: 'report-filters-modal-window-close',
  reportFiltersModalHeader: 'report-filters-modal-window-header',
  reportFiltersModalApplyButton: 'report-filters-modal-apply-button',
  reportActiveFiltersLabel: 'report-filters-active-filters-label',
  reportActiveFiltersGenLabel: 'report-filters-active-filters-gen',
  reportActiveFiltersProductLabel: 'report-filters-active-filters-product',
  reportActiveFiltersAccountLabel: 'report-filters-active-filters-account',

  // filter options:
  reportFilterByGenerationFrontline: 'report-filter-by-gen-frontline',
  reportFilterByGenerationGenZero: 'report-filter-by-gen-genZero',
  reportFilterByGenerationAll: 'report-filter-by-gen-all',
  reportFilterByProductsAll: 'report-filter-by-products-all',
  reportFilterByProductsActive: 'report-filter-by-products-active',
  reportFilterByAccountAll: 'report-filter-by-account-all',
  reportFilterByAccountNew: 'report-filter-by-account-new',
  // candidates
  reportCandidateSource: 'report-ca-source',
  reportCandidateDateAdded: 'report-candidate-date-added',
  reportCandidateAcceptBy: 'report-candidate-accept-by',
  reportCandidateDisposition: 'report-candidate-disposition',
  reportReferralExpirationDate: 'report-referral-expiration-date',

  reportFCV: 'report-fcv',
  reportFCVValue: 'report-fcv-value',
  reportFCVLabel: 'report-fcv-label',

  reportCoachClients: 'report-coach-clients-count',
  reportCoachNewClients: 'report-coach-clients-new',
  reportCoachClientsReactivated: 'report-coach-clients-reactivated',

  reportFiltersBtn: 'report-filters-button',
  reportFiltersLabel: 'report-filters-label',
  rankFilterCheckbox: 'rank-filter-checkbox-',
  closeToNextRankCheckbox: 'close-to-next-rank-checkbox',
  newCoachesJoinedFilter: 'new-coaches-joined-filter',
  fibcFilter: 'fibc-filter',
  bonusFilter: 'bonus-filter',
};

export default reportsTestIDs;
